import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  normalizedLeadFilterSearchParams,
  readLeadFiltersFromSearchParams,
} from '@/models/ui/leadFilterSearchParams.ts';
import type { LeadFilters } from '@/models/ui/leadFilters.ts';

export function useLeadFilters(): LeadFilters {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const normalizedParams = normalizedLeadFilterSearchParams(searchParams);
    if (normalizedParams.toString() !== searchParams.toString()) {
      setSearchParams(normalizedParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return readLeadFiltersFromSearchParams(searchParams);
}
